import { createFileRoute, useRouter } from '@tanstack/react-router'
import { withSessionRedirect } from '../lib/require-session.ts'
import { EmptyState } from '../components/ui/index.ts'
import { VaultTenantKey } from '../components/VaultTenantKey.tsx'
import { fetchHierarchy } from '../lib/hierarchy-api.ts'
import { getTenantKey, listDaemons } from '../lib/vault-api.ts'
import { useIsUnlocked } from '../lib/vault-unlock.ts'

export const Route = createFileRoute('/vault/tenant-key')({
  loader: async () =>
    withSessionRedirect(async () => {
      const tree = await fetchHierarchy()
      const rootId = tree.roots[0]?.id ?? ''
      if (!rootId) return { rootId, tenantKey: null, daemons: [] }
      const [tenantKey, daemons] = await Promise.all([
        getTenantKey(rootId),
        listDaemons(rootId),
      ])
      return {
        rootId,
        tenantKey,
        daemons: daemons.filter((d) => d.status === 'approved'),
      }
    }),
  component: VaultTenantKeyRoute,
})

function VaultTenantKeyRoute() {
  const { rootId, tenantKey, daemons } = Route.useLoaderData()
  const router = useRouter()
  const unlocked = useIsUnlocked()

  // No root means the hierarchy is empty, not that the key is missing —
  // a bare "No root yet" line read as a rendering failure.
  if (!tenantKey)
    return (
      <EmptyState
        headline="No root node yet"
        description="This vault has no hierarchy root, so there is nothing to hold a tenant key. Create one on the Projects page first."
      />
    )

  return (
    <VaultTenantKey
      rootId={rootId}
      tenantKey={tenantKey}
      daemons={daemons}
      unlocked={unlocked}
      onChanged={async () => {
        await router.invalidate()
      }}
    />
  )
}
